export const getLatLongDisplay = (latLong?: string) => {
  if (!latLong) return 'Location not set';
  try {
  let parsed: any = JSON.parse(latLong);
  if (Array.isArray(parsed)) parsed = parsed[0];
  const lat = parsed.lat ?? parsed.latitude ?? parsed.lattitude;
  const lng = parsed.lng ?? parsed.longitude ?? parsed.long ?? parsed.lon;
  if (typeof lat !== 'undefined' && typeof lng !== 'undefined') return `${lat}, ${lng}`;
  } catch {
    // fallthrough
  }
  return latLong;
};

export const parseLatLngToJsonString = (value?: string) => {
  if (!value) return undefined;
  // Accept formats like "12.34, 56.78" or already a JSON string
  try {
    let parsed: any = JSON.parse(value);
    if (Array.isArray(parsed)) parsed = parsed[0];
    if (parsed && typeof parsed === 'object') {
      const lat = parsed.lat ?? parsed.latitude ?? parsed.lattitude;
      const lng = parsed.lng ?? parsed.longitude ?? parsed.long ?? parsed.lon;
      if (typeof lat !== 'undefined' && typeof lng !== 'undefined') {
        const latNum = Number(lat);
        const lngNum = Number(lng);
        return JSON.stringify({ lat: Number.isNaN(latNum) ? lat : latNum, lng: Number.isNaN(lngNum) ? lng : lngNum });
      }
    }
  } catch {
    // Not JSON, try to parse as comma separated
    const parts = value.split(',').map((s) => s.trim());
    if (parts.length === 2) {
      const lat = Number(parts[0]);
      const lng = Number(parts[1]);
      if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
        return JSON.stringify({ lat, lng });
      }
    }
  }
  return value; // fallback to raw string
};

export const formatDate = (dateString?: string) => {
  if (!dateString) return '';
  const d = new Date(dateString);
  if (Number.isNaN(d.getTime())) return dateString;
  return d.toLocaleDateString();
};
